var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdituser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.123047,
    y: 0.950684,
    width: 20.9893,
    height: 20.9893,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5296_252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.083 9.93516C15.803 9.93516 15.583 10.1552 15.583 10.4352V19.5352H2.58301V6.53516H11.683C11.963 6.53516 12.183 6.31516 12.183 6.03516C12.183 5.75516 11.963 5.53516 11.683 5.53516H2.58301C2.03301 5.53516 1.58301 5.98516 1.58301 6.53516V19.5352C1.58301 20.0852 2.03301 20.5352 2.58301 20.5352H15.583C16.133 20.5352 16.583 20.0852 16.583 19.5352V10.4352C16.583 10.1552 16.363 9.93516 16.083 9.93516Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5227 4.84522L17.4927 2.52522C17.4027 2.42522 17.2727 2.35522 17.1327 2.35522C16.9927 2.35522 16.8627 2.40522 16.7627 2.50522L8.72266 10.6652C8.67266 10.7152 8.63266 10.7852 8.60266 10.8552L7.58266 13.8552C7.52266 14.0352 7.56266 14.2252 7.70266 14.3652C7.80266 14.4652 7.93266 14.5152 8.06266 14.5152C8.11266 14.5152 8.16266 14.5152 8.21266 14.4952L11.2627 13.5552C11.3427 13.5352 11.4127 13.4952 11.4627 13.4352L19.5027 5.54522C19.6927 5.35522 19.7027 5.05522 19.5327 4.85522L19.5227 4.84522ZM10.8427 12.6252L8.84266 13.2452L9.51266 11.2852L17.0927 3.58522L18.4627 5.14522L10.8527 12.6252H10.8427Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5296_252"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.07,
    height: 18.18,
    fill: "white",
    transform: "translate(1.58301 2.35522)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdituser);
export default __webpack_public_path__ + "static/media/edituser.43ebead41d5e1eb6e4167b5ca0fa422a.svg";
export { ForwardRef as ReactComponent };